import { v4 as uuidv4 } from 'uuid';
import defaultProfile from './data/profile.json';
import { getProfileAPI } from './api';

function minutesToLabel(mins) {
    if (!mins) return '0m';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

function buildProfileDisplay(p, countryInfo = {}) {
    const density = p.scheduleDensity || {};
    const totalMins = density.totalCalendarMinutesMonth || 1;
    const bookedMins = density.timeBookedMinutesMonth || 0;
    const firstName = p.firstName || '';
    const lastName = p.lastName || '';
    const email = p.email || '';
    const nameInitials = `${firstName.trim()[0] || ''}${lastName.trim()[0] || ''}`.toUpperCase();

    return {
        displayName:        `${firstName} ${lastName}`.trim(),
        firstName,
        lastName,
        email,
        // Falls back to the email's first letter when no name is set at all.
        avatarInitials:     nameInitials || (email[0] || '').toUpperCase(),
        personaType:        p.personaType || '',
        role:               p.role || '',

        city:               countryInfo.city || '',
        country:            countryInfo.countryName || countryInfo.country || '',
        timezone:           countryInfo.timezone || '',

        engagementScore:    p.engagementScore || 0,
        engagementTotal:    p.engagementTotal || 1000,
        engagementPct:      Math.round(((p.engagementScore || 0) / (p.engagementTotal || 1000)) * 100 * 10) / 10,
        rankingPublisher:   p.rankingPublisher ? `#${p.rankingPublisher}` : '—',
        rankingCountry:     p.rankingCountry   ? `#${p.rankingCountry.toLocaleString()}` : '—',
        rankingWorld:       p.rankingWorld     ? `#${p.rankingWorld.toLocaleString()}` : '—',
        rankingCountryName: countryInfo.countryName || countryInfo.country || '',

        eventsThisMonth:    density.eventImpressionsMonth || 0,
        timeBookedLabel:    minutesToLabel(bookedMins),
        scheduleDensityPct: Math.round((bookedMins / totalMins) * 100 * 10) / 10,
    };
}

async function getProfile(session) {
    if (session.payload) {
        const merged = { ...defaultProfile, ...session.payload };
        this.profile = merged;
        this.profileDisplay = {
            ...buildProfileDisplay(merged, this.env.countryInfo),
            connectedDevices: this.profileDisplay.connectedDevices || '',
        };
        this.observed.profile = uuidv4();
    }

    const res = await getProfileAPI({
        store: this,
        token: session.token,
        traceId: this.env.traceId,
    });

    if (res?.data?.data) {
        const merged = { ...defaultProfile, ...session.payload, ...res.data.data };
        this.profile = merged;
        this.profileDisplay = {
            ...buildProfileDisplay(merged, this.env.countryInfo),
            connectedDevices: this.profileDisplay.connectedDevices || '',
        };
        this.observed.profile = uuidv4();
    }
}

export default getProfile;
